/**
 * Theme loader for the cart "Complete the look" upsell (assets/cart-dining-upsell.js,
 * loaded from layout/theme.liquid).
 *
 * On for every shopper. A cart row only gets an offer when its product has the
 * metafield custom.cart_upsell set, so products without it are untouched.
 *
 * QA: ?mf_cdu=0 in the URL turns it off for this browser session,
 * ?mf_cdu=1 turns it back on.
 *
 * The upsell itself guards on window.__cartDiningUpsell, so if the old full
 * Intelligems variant code is ever started as well, it runs only once.
 */
(function () {
  var FLAG = 'mf_cdu';

  try {
    var param = new URLSearchParams(window.location.search).get(FLAG);
    if (param === '0') sessionStorage.setItem(FLAG, '0');
    if (param === '1') sessionStorage.removeItem(FLAG);
  } catch (e) {}

  function enabled() {
    try { return sessionStorage.getItem(FLAG) !== '0'; } catch (e) { return true; }
  }

  function run() {
    /**
     * Modish Furnishing - Cart "Complete the look" upsell
     *
     * Under a dining chair / dining table / bar stool line in the cart drawer and
     * on the cart page, shows one attached row offering the piece it is
     * photographed with:
     *   chair  -> matching dining table (qty 1)
     *   table  -> matching dining chair (qty 4, adjustable)
     *   stool  -> matching dining chair (qty = stool qty, max 6). Once that chair
     *             is in the cart, the chair line offers its table.
     *   Any other product with the metafield set: its upsell, qty 1.
     * WHAT IS OFFERED comes from the product metafield custom.cart_upsell (a
     * product reference), set per product in the Shopify admin. Optional
     * custom.cart_upsell_qty (integer) sets the offered quantity. Without it:
     *   stool -> chair: the stool quantity (max 6), table -> chair: 4, else 1.
     * snippets/cart-products.liquid prints both onto each cart row
     * (data-cdu-offer, -title, -type, -img, -qty), so offers are worked out from the
     * cart rows themselves and nothing waits on /cart.js.
     * Offered products' /products/<handle>.js is prefetched and cached in
     * sessionStorage.
     *
     * Why it re-renders inside the MutationObserver callback: the theme morphs the
     * cart rows on every add / quantity change and drops anything it did not
     * render. Re-adding in the same microtask (before paint) keeps the row from
     * flickering and the quantity buttons from jumping under the shopper's finger.
     *
     * Rules: only on lines whose product has custom.cart_upsell set, one offer per
     * line, max 2 per cart,
     * never offers something already in the cart, no table offer when the cart
     * already has a dining table, no chair offer when it already has dining
     * chairs, hidden when sold out.
     * Price shown = the shopper's Intelligems price (igData.price) when IG has one,
     * otherwise the Shopify price. Adds via /cart/add.js with the cart sections and
     * the theme's own cart:update event, so drawer, cart page and bubble re-render
     * in place.
     *
     * Tracking: dataLayer events cdu_offer_shown / cdu_offer_added, cart
     * attributes _cdu_shown / _cdu_added, line property _cdu_upsell on added items,
     * IG custom events on .cdu-offer (viewed) and .cdu-add (clicked, row or popup).
     *
     * Quick view: clicking the offer's image or name opens a compact PDP popup
     * (photos with swipe / arrows / dots, title, price, dimensions, qty,
     * Add to cart, See full details).
     * The row's Add button still adds directly.
     *
     * Add button: shows a spinner and is disabled while the item is added.
     *
     * Debug: window.__cduDebug = true, then window.__cartDiningUpsellInfo().
     */
    (function () {
      if (window.__cartDiningUpsell) return;
      window.__cartDiningUpsell = true;

      var VERSION = '2.0.0';
      var STYLE_ID = 'cdu-style';
      var MAX_OFFERS = 2;
      var CACHE_MS = 20 * 60 * 1000;
      var GOLD = '#b79c5d';


      // Shopify product type -> table (t) / chair (c) / stool (s)
      function kindOf(type) {
        type = String(type || '').toLowerCase();
        if (type.indexOf('table') > -1) return 't';
        if (type.indexOf('chair') > -1) return 'c';
        if (type.indexOf('stool') > -1) return 's';
        return '';
      }

      var state = { products: {}, pending: {}, alloc: [], qty: {}, added: {}, busy: false, errors: [], cart: null };

      function log() {
        if (!window.__cduDebug) return;
        try { console.log.apply(console, ['[cart-dining-upsell]'].concat([].slice.call(arguments))); } catch (e) {}
      }

      function ss(key, val) {
        try {
          if (val === undefined) { var raw = sessionStorage.getItem(key); return raw ? JSON.parse(raw) : null; }
          sessionStorage.setItem(key, JSON.stringify(val));
        } catch (e) { return null; }
      }

      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
      }

      function money(n) {
        return '£' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      /* ---------- data ---------- */

      // "Dimensions:" block of the product description, one entry per line,
      // e.g. ["Width 56cm x Depth 53cm x Height 76cm", "Seat Height 49cm"].
      function dimsFrom(html) {
        try {
          var box = document.createElement('div');
          box.innerHTML = String(html || '').replace(/<(br|\/p|\/div|\/li|\/h\d)[^>]*>/gi, '\n');
          var part = (box.textContent || '').split(/dimensions\s*:?/i)[1];
          if (!part) return [];
          part = part.split(/specifications|features|care\b|assembly|delivery|materials?\s*:/i)[0];
          var segs = part.split('\n').map(function (s) { return s.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
          var out = [];
          for (var i = 0; i < segs.length; i++) {
            // "Seat Height" on one line and "49cm" on the next: join them.
            if (!/\d/.test(segs[i]) && segs[i + 1] && /\d/.test(segs[i + 1])) { out.push(segs[i] + ' ' + segs[i + 1]); i++; }
            else if (/\d/.test(segs[i])) out.push(segs[i]);
          }
          return out.slice(0, 4);
        } catch (e) { return []; }
      }

      function sizedImg(src, w) {
        src = String(src || '');
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }

      // Sync read of the cache; starts a fetch (and re-renders when it lands) on a miss.
      function product(handle) {
        if (state.products[handle]) return state.products[handle];
        var cached = ss('cdu:p2:' + handle);
        if (cached && Date.now() - cached.t < CACHE_MS) { state.products[handle] = cached.d; return cached.d; }
        if (!state.pending[handle]) {
          state.pending[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (!p) return;
              var v = (p.variants || []).filter(function (x) { return x.available; })[0] || null;
              var d = v ? {
                id: v.id, productId: p.id, price: v.price, compare: v.compare_at_price, available: true,
                title: p.title, handle: handle, images: (p.images || []).slice(0, 6), dims: dimsFrom(p.description)
              } : { available: false };
              state.products[handle] = d;
              ss('cdu:p2:' + handle, { t: Date.now(), d: d });
              render();
            })
            .catch(function () {})
            .then(function () { delete state.pending[handle]; });
        }
        return null;
      }

      function getCart() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { state.cart = c; return c; });
      }

      function igPrice(d) {
        var out = { price: d.price / 100, compare: d.compare ? d.compare / 100 : 0 };
        try {
          var p = window.igData && window.igData.price;
          if (p && p.getPriceByVariantId) {
            var ip = parseFloat(p.getPriceByVariantId(d.id));
            if (isFinite(ip) && ip > 0) out.price = ip;
            var ic = parseFloat(p.getComparePriceByVariantId && p.getComparePriceByVariantId(d.id));
            if (isFinite(ic) && ic > 0) out.compare = ic;
          }
        } catch (e) {}
        if (!(out.compare > out.price)) out.compare = 0;
        return out;
      }

      /* ---------- plan (sync, from the DOM) ---------- */

      function rows() {
        return [].slice.call(document.querySelectorAll('tr.cart-items__table-row[data-key]')).filter(function (r) {
          return !r.getAttribute('data-parent-key');
        });
      }

      function lines() {
        var seen = {}, out = [];
        rows().forEach(function (r) {
          var key = r.getAttribute('data-key');
          if (seen[key]) return;
          seen[key] = 1;
          var input = r.querySelector('input[name="updates[]"]');
          out.push({
            key: key,
            vid: key.split(':')[0],
            qty: Math.max(parseInt(input && input.value, 10) || 1, 1),
            handle: r.getAttribute('data-cdu-handle') || '',
            kind: kindOf(r.getAttribute('data-cdu-type')),
            offer: r.getAttribute('data-cdu-offer') || '',
            offerTitle: r.getAttribute('data-cdu-offer-title') || '',
            offerKind: kindOf(r.getAttribute('data-cdu-offer-type')),
            offerImg: r.getAttribute('data-cdu-offer-img') || '',
            offerQty: parseInt(r.getAttribute('data-cdu-offer-qty'), 10) || 0
          });
        });
        return out;
      }

      function plan() {
        var ls = lines();
        var vids = {}, hasTable = false, hasChair = false;
        ls.forEach(function (l) {
          vids[l.vid] = 1;
          if (l.kind === 't') hasTable = true;
          if (l.kind === 'c') hasChair = true;
        });
        var alloc = [];
        ls.forEach(function (l) {
          if (alloc.length >= MAX_OFFERS) return;
          if (!l.offer || l.offer === l.handle) return;
          // Already has a table / chairs: don't push a second one.
          if (l.offerKind === 't' && hasTable) return;
          if (l.offerKind === 'c' && hasChair) return;
          if (alloc.some(function (c) { return c.offer === l.offer; })) return;
          var d = product(l.offer);
          if (!d || !d.available || vids[String(d.id)]) return;
          // mode: 1 = fixed qty 1, 's' = follows the stool qty, 'n' = adjustable from a start qty
          var mode, base;
          if (l.offerQty > 1) { mode = 'n'; base = l.offerQty; }
          else if (l.offerQty === 1) { mode = 1; base = 1; }
          else if (l.kind === 's' && l.offerKind === 'c') { mode = 's'; base = Math.min(l.qty, 6); }
          else if (l.kind === 't' && l.offerKind === 'c') { mode = 'n'; base = 4; }
          else { mode = 1; base = 1; }
          var qk = l.key + '>' + l.offer;
          var qty = mode === 1 ? 1 : state.qty[qk] || base;
          alloc.push({
            key: l.key, trigger: l.handle, offer: l.offer, mode: mode, data: d, qty: qty, qk: qk,
            title: l.offerTitle || d.title, img: l.offerImg, offerKind: l.offerKind
          });
        });
        return alloc;
      }

      /* ---------- render ---------- */

      function css() {
        if (document.getElementById(STYLE_ID)) return;
        var s = '' +
          '.cdu-cell{grid-column:1/-1;display:block;padding:0;margin:0;border:0;min-width:0;width:100%}' +
          '.cdu-offer{display:grid;grid-template-columns:64px minmax(0,1fr) auto;gap:8px 12px;align-items:center;margin:12px 0 0;padding:10px 12px;background:#faf8f3;border:0;border-left:2px solid ' + GOLD + ';border-radius:0;font:inherit;color:inherit;text-align:left}' +
          '.cdu-offer *{box-sizing:border-box;border-radius:0}' +
          '.cdu-img{width:64px;height:64px;object-fit:contain;background:#fff;display:block}' +
          '.cdu-offer--qty .cdu-img{grid-row:span 2;align-self:start}' +
          '.cdu-text{min-width:0;font-size:13px;line-height:1.4}' +
          '.cdu-label{color:#8a7440}' +
          '.cdu-name{color:inherit;font-weight:500}' +
          '.cdu-price{margin-top:4px;font-size:13px}' +
          '.cdu-price s{opacity:.55;margin-left:6px;font-size:12px}' +
          '.cdu-each{opacity:.6;font-size:12px;margin-left:3px}' +
          '.cdu-actions{display:flex;align-items:center;gap:10px;justify-content:flex-end}' +
          '.cdu-offer--qty .cdu-actions{grid-column:2/-1}' +
          '.cdu-qty{display:inline-flex;align-items:center;height:40px;border:1px solid #cfcac0;background:#fff}' +
          '.cdu-qty button{all:unset;cursor:pointer;width:36px;height:38px;text-align:center;font-size:16px;line-height:38px;color:#1f1f1f;touch-action:manipulation}' +
          '.cdu-qty button:focus-visible{outline:2px solid ' + GOLD + ';outline-offset:-2px}' +
          '.cdu-qty span{min-width:24px;text-align:center;font-size:14px;color:#1f1f1f}' +
          'button.cdu-add{all:unset;box-sizing:border-box;cursor:pointer;display:inline-flex !important;align-items:center;justify-content:center;height:40px;min-width:80px;padding:0 20px;background:#1f1f1f !important;color:#fff !important;border:1px solid #1f1f1f !important;border-radius:0 !important;font:inherit;font-size:13px !important;font-weight:600;letter-spacing:.06em;white-space:nowrap;touch-action:manipulation}' +
          'button.cdu-add:focus-visible{outline:2px solid ' + GOLD + ';outline-offset:2px}' +
          'button.cdu-add[disabled]{opacity:.6;cursor:default}' +
          'button.cdu-add.is-loading[disabled]{opacity:1;cursor:progress}' +
          '.cdu-spin{display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50% !important;animation:cdu-spin .7s linear infinite}' +
          '@keyframes cdu-spin{to{transform:rotate(360deg)}}' +
          '@media (prefers-reduced-motion:reduce){.cdu-spin{animation-duration:1.6s}}' +
          '.cdu-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}' +
          '.cdu-err{grid-column:1/-1;font-size:12px;color:#a32d2d}' +
          '.cdu-done{display:flex;align-items:center;gap:6px;margin:12px 0 0;font-size:13px;color:#8a7440}' +
          '.cdu-done svg{flex:0 0 auto;width:16px;height:16px;color:' + GOLD + '}' +
          '[data-cdu-open]{cursor:pointer}' +
          '[data-cdu-open]:focus-visible{outline:2px solid ' + GOLD + ';outline-offset:2px}' +
          '.cdu-text[data-cdu-open]:hover .cdu-name{text-decoration:underline;text-underline-offset:2px}' +
          /* quick view */
          'dialog.cdu-qv{padding:0;border:0;border-radius:0;width:92vw;max-width:680px;max-height:90vh;overflow:hidden;background:#fff;color:#1f1f1f;font:inherit;box-shadow:0 12px 40px rgba(0,0,0,.25)}' +
          'dialog.cdu-qv::backdrop{background:rgba(0,0,0,.5)}' +
          '.cdu-qv *{box-sizing:border-box;border-radius:0}' +
          '.cdu-qv__grid{display:grid;grid-template-columns:1fr;max-height:90vh}' +
          '.cdu-qv__media{position:relative;background:#f7f5f0}' +
          '.cdu-qv__track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;touch-action:pan-x pan-y;overscroll-behavior-x:contain}' +
          '.cdu-qv__track::-webkit-scrollbar{display:none}' +
          '.cdu-qv__track img{flex:0 0 100%;width:100%;aspect-ratio:1/1;max-height:44vh;object-fit:cover;scroll-snap-align:start;display:block}' +
          '.cdu-qv__nav{all:unset;box-sizing:border-box;position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.92);border:1px solid #ddd;cursor:pointer;color:#1f1f1f;font-size:22px;line-height:1;touch-action:manipulation}' +
          '.cdu-qv__nav--prev{left:10px}.cdu-qv__nav--next{right:10px}' +
          '.cdu-qv__nav[disabled]{opacity:.35;cursor:default}' +
          '.cdu-qv__nav:focus-visible{outline:2px solid ' + GOLD + ';outline-offset:2px}' +
          '.cdu-qv__dots{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:2px;z-index:2}' +
          '.cdu-qv__dots button{all:unset;box-sizing:content-box;width:8px;height:8px;padding:6px;background:rgba(255,255,255,.75);background-clip:content-box;cursor:pointer;touch-action:manipulation;outline-offset:-4px}' +
          '.cdu-qv__dots button[aria-current="true"]{background-color:#1f1f1f}' +
          '.cdu-qv__dots button:focus-visible{outline:2px solid ' + GOLD + '}' +
          '.cdu-qv__body{padding:20px 20px 22px;overflow-y:auto;display:flex;flex-direction:column;gap:14px}' +
          '.cdu-qv__kicker{font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#8a7440}' +
          '.cdu-qv__title{margin:0;font-family:var(--font-heading--family,"Playfair Display",serif);font-size:22px;line-height:1.2;font-weight:500;padding-right:28px}' +
          '.cdu-qv__price{font-size:17px}' +
          '.cdu-qv__price s{opacity:.55;margin-left:8px;font-size:14px}' +
          '.cdu-qv__dims-label{font-size:12px;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin-bottom:4px}' +
          '.cdu-qv__dims ul{list-style:none;margin:0;padding:0;font-size:14px;line-height:1.5}' +
          '.cdu-qv__buy{display:flex;gap:10px;align-items:stretch}' +
          '.cdu-qv__buy .cdu-qty{height:48px}.cdu-qv__buy .cdu-qty button{height:46px;line-height:46px;width:40px}' +
          'button.cdu-qv__add{all:unset;box-sizing:border-box;flex:1;cursor:pointer;display:flex !important;align-items:center;justify-content:center;height:48px;padding:0 20px;background:#1f1f1f !important;color:#fff !important;font:inherit;font-size:14px !important;font-weight:600;letter-spacing:.06em;touch-action:manipulation}' +
          'button.cdu-qv__add[disabled]{opacity:.6;cursor:default}' +
          'button.cdu-qv__add:focus-visible{outline:2px solid ' + GOLD + ';outline-offset:2px}' +
          'a.cdu-qv__more{display:flex;align-items:center;justify-content:center;height:48px;border:1px solid #1f1f1f;color:#1f1f1f;text-decoration:none;font-size:14px;font-weight:500;letter-spacing:.04em}' +
          '.cdu-qv__close{all:unset;position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #ddd;cursor:pointer;font-size:20px;line-height:1;color:#1f1f1f}' +
          '.cdu-qv__close:focus-visible{outline:2px solid ' + GOLD + '}' +
          '.cdu-qv .cdu-err{font-size:12px;color:#a32d2d}' +
          '@media (min-width:750px){.cdu-qv__grid{grid-template-columns:1fr 1fr}.cdu-qv__track img{max-height:none}.cdu-qv__body{justify-content:center;padding:32px 28px}}' +
          '@media (min-width:750px){.cdu-offer--page.cdu-offer--qty{grid-template-columns:64px minmax(0,1fr) auto}.cdu-offer--page.cdu-offer--qty .cdu-img{grid-row:auto;align-self:center}.cdu-offer--page.cdu-offer--qty .cdu-actions{grid-column:auto}}';
        var el = document.createElement('style');
        el.id = STYLE_ID;
        el.textContent = s;
        document.head.appendChild(el);
      }

      var CHECK = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 10.5l3.2 3.2L15 6.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"></path></svg>';

      function offerHtml(c, surface) {
        var pr = igPrice(c.data);
        var hasQty = c.mode !== 1;
        var img = c.img || (c.data.images && c.data.images[0] ? sizedImg(c.data.images[0], 200) : '');
        if (img.indexOf('//') === 0) img = 'https:' + img;
        return '' +
          '<div class="cdu-offer cdu-offer--' + surface + (hasQty ? ' cdu-offer--qty' : ' cdu-offer--noqty') + '" data-cdu-offer="' + esc(c.offer) + '" data-cdu-trigger="' + esc(c.trigger) + '">' +
            '<img class="cdu-img" data-cdu-open src="' + esc(img) + '" alt="View ' + esc(c.title) + '" role="button" tabindex="0" aria-haspopup="dialog" decoding="async" width="64" height="64">' +
            '<div class="cdu-text" data-cdu-open role="button" tabindex="0" aria-haspopup="dialog">' +
              '<div><span class="cdu-label">Complete the look:</span> <span class="cdu-name">' + esc(c.title) + '</span></div>' +
              '<div class="cdu-price">' + money(pr.price) + (hasQty ? '<span class="cdu-each">each</span>' : '') + (pr.compare ? '<s>' + money(pr.compare) + '</s>' : '') + '</div>' +
            '</div>' +
            '<div class="cdu-actions">' +
              (hasQty ? '<div class="cdu-qty"><button type="button" data-cdu-step="-1" aria-label="Decrease quantity">&minus;</button><span data-cdu-qty>' + c.qty + '</span><button type="button" data-cdu-step="1" aria-label="Increase quantity">+</button></div>' : '') +
              '<button type="button" class="cdu-add" aria-label="Add ' + esc(c.title) + ' to cart"><span class="cdu-label-text">Add</span></button>' +
            '</div>' +
          '</div>';
      }

      function surfaceOf(row) {
        return row.closest('.cart-drawer, cart-drawer-component, .cart-drawer__dialog') ? 'drawer' : 'page';
      }

      var rendering = false;
      function render() {
        if (rendering) return;
        rendering = true;
        try {
          state.alloc = plan();
          var byKey = {};
          state.alloc.forEach(function (c) { byKey[c.key] = c; });
          rows().forEach(function (row) {
            var key = row.getAttribute('data-key');
            var c = byKey[key];
            var cell = row.querySelector(':scope > .cdu-cell');
            var done = state.added[key] && Date.now() < state.added[key].until ? state.added[key] : null;
            var want = c ? 'offer:' + c.offer + ':' + c.qty : done ? 'done:' + done.text : '';
            if (!want) { if (cell) cell.remove(); return; }
            if (cell && cell.getAttribute('data-cdu-state') === want) return;
            if (!cell) {
              cell = document.createElement('td');
              cell.className = 'cdu-cell';
              cell.setAttribute('role', 'cell');
              row.appendChild(cell);
            }
            cell.setAttribute('data-cdu-state', want);
            if (c) {
              var surface = surfaceOf(row);
              cell.innerHTML = offerHtml(c, surface);
              watchShown(cell.firstChild, c, surface);
            } else {
              cell.innerHTML = '<div class="cdu-done" role="status">' + CHECK + '<span>' + esc(done.text) + '</span></div>';
            }
          });
        } catch (e) {
          state.errors.push({ t: Date.now(), err: String(e) });
        }
        rendering = false;
      }

      /* ---------- tracking ---------- */

      // "Shown" means actually on screen (a closed drawer still holds rendered rows).
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || !en.target.__cdu) return;
          track('shown', en.target.__cdu.c, en.target.__cdu.surface);
          io.unobserve(en.target);
        });
      }, { threshold: 0.6 }) : null;

      function watchShown(el, c, surface) {
        if (!el) return;
        if (!io) { track('shown', c, surface); return; }
        el.__cdu = { c: c, surface: surface };
        io.observe(el);
      }

      function dl(ev, c, extra) {
        try {
          window.dataLayer = window.dataLayer || [];
          var o = { event: ev, cdu_trigger: c.trigger, cdu_offer: c.offer, cdu_offer_type: c.offerKind === 't' ? 'table' : c.offerKind === 'c' ? 'chair' : 'other' };
          for (var k in extra) o[k] = extra[k];
          window.dataLayer.push(o);
        } catch (e) {}
      }

      function setAttr(name, value) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: (function () { var a = {}; a[name] = value; return a; })() })
        }).catch(function () {});
      }

      function track(kind, c, surface, qty, value, from) {
        if (kind === 'shown') {
          var sk = c.trigger + '>' + c.offer;
          var seen = ss('cdu:shown') || {};
          if (seen[sk]) return;
          seen[sk] = 1;
          ss('cdu:shown', seen);
          dl('cdu_offer_shown', c, { cdu_surface: surface });
          // Deferred so it never races a quantity change the shopper is making.
          if (!ss('cdu:attrShown')) { ss('cdu:attrShown', 1); setTimeout(function () { setAttr('_cdu_shown', 'yes'); }, 2500); }
          log('shown', sk, surface);
        } else {
          dl('cdu_offer_added', c, { cdu_surface: surface, cdu_from: from || 'row', cdu_qty: qty, value: value, currency: 'GBP' });
          var added = ss('cdu:addedList') || [];
          added.push(c.offer + ' x' + qty);
          ss('cdu:addedList', added);
          setAttr('_cdu_added', added.join(', '));
          log('added', c.offer, qty);
        }
      }

      /* ---------- add ---------- */

      function sectionIds() {
        return [].slice.call(document.querySelectorAll('cart-items-component')).map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
      }

      function add(c, qty, btn, surface, from) {
        if (state.busy) return;
        state.busy = true;
        var label = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.innerHTML = '<span class="cdu-spin" aria-hidden="true"></span><span class="cdu-sr">Adding</span>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: c.data.id, quantity: qty, properties: { _cdu_upsell: c.trigger } }],
            sections: sectionIds().join(','),
            sections_url: location.pathname
          })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            if (state.qv) state.qv.close();
            state.added[c.key] = { text: c.title + ' added to your set', until: Date.now() + 8000 };
            setTimeout(render, 8100);
            // Stop the spinner even if the theme does not re-render this row.
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.innerHTML = label;
            track('added', c, surface, qty, Math.round(igPrice(c.data).price * qty * 100) / 100, from);
            return getCart().then(function (cart) {
              var drawer = document.querySelector('cart-drawer-component');
              var hadAuto = drawer && drawer.hasAttribute('auto-open');
              // On the cart page, don't let the theme pop the drawer open over it.
              if (surface === 'page' && hadAuto) drawer.removeAttribute('auto-open');
              var ev = new Event('cart:update', { bubbles: true });
              ev.detail = { resource: cart, sourceId: 'cart-dining-upsell', data: { source: 'cart-dining-upsell', itemCount: cart.item_count, productId: String(c.data.productId), variantId: String(c.data.id), sections: res.sections || {} } };
              document.dispatchEvent(ev);
              if (surface === 'page' && hadAuto) drawer.setAttribute('auto-open', '');
              render();
            });
          })
          .catch(function (err) {
            log('add failed', err);
            state.errors.push({ t: Date.now(), offer: c.offer, err: err && (err.description || err.message) });
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.innerHTML = label;
            var box = btn.closest('.cdu-offer, .cdu-qv__body');
            if (box && !box.querySelector('.cdu-err')) {
              box.insertAdjacentHTML('beforeend', '<div class="cdu-err" role="alert">' + esc((err && err.description) || 'This could not be added. Try again.') + '</div>');
            }
          })
          .then(function () { state.busy = false; });
      }

      /* ---------- quick view ---------- */

      // A compact PDP in a native <dialog>: showModal() puts it in the top layer,
      // above the cart drawer (itself a modal dialog).
      function openQuickView(c, surface) {
        var d = c.data;
        if (!d || !d.title) return;
        if (state.qv) state.qv.close();
        var pr = igPrice(d);
        var hasQty = c.mode !== 1;
        var srcs = d.images && d.images.length ? d.images : (c.img ? [c.img] : []);
        var nImg = srcs.length;
        var imgs = srcs.map(function (src, i) {
          return '<img src="' + esc(sizedImg(src, 900)) + '" alt="' + (i ? '' : esc(d.title)) + '" decoding="async">';
        }).join('');
        var dlg = document.createElement('dialog');
        dlg.className = 'cdu-qv';
        dlg.setAttribute('aria-label', d.title);
        dlg.innerHTML = '' +
          '<button type="button" class="cdu-qv__close" aria-label="Close">&times;</button>' +
          '<div class="cdu-qv__grid">' +
            '<div class="cdu-qv__media"><div class="cdu-qv__track">' + imgs + '</div>' +
              (nImg > 1 ? '<button type="button" class="cdu-qv__nav cdu-qv__nav--prev" aria-label="Previous image" disabled>&#8249;</button>' +
                '<button type="button" class="cdu-qv__nav cdu-qv__nav--next" aria-label="Next image">&#8250;</button>' +
                '<div class="cdu-qv__dots">' + Array.apply(null, Array(nImg)).map(function (_, i) {
                  return '<button type="button" data-cdu-qv-go="' + i + '" aria-label="Image ' + (i + 1) + ' of ' + nImg + '"' + (i ? '' : ' aria-current="true"') + '></button>';
                }).join('') + '</div>' : '') +
            '</div>' +
            '<div class="cdu-qv__body">' +
              '<div class="cdu-qv__kicker">Complete the look</div>' +
              '<h2 class="cdu-qv__title">' + esc(d.title) + '</h2>' +
              '<div class="cdu-qv__price">' + money(pr.price) + (hasQty ? ' <span class="cdu-each">each</span>' : '') + (pr.compare ? '<s>' + money(pr.compare) + '</s>' : '') + '</div>' +
              (d.dims && d.dims.length ? '<div class="cdu-qv__dims"><div class="cdu-qv__dims-label">Dimensions</div><ul>' + d.dims.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' : '') +
              '<div class="cdu-qv__buy">' +
                (hasQty ? '<div class="cdu-qty"><button type="button" data-cdu-qv-step="-1" aria-label="Decrease quantity">&minus;</button><span data-cdu-qv-qty>' + c.qty + '</span><button type="button" data-cdu-qv-step="1" aria-label="Increase quantity">+</button></div>' : '') +
                '<button type="button" class="cdu-qv__add cdu-add"><span class="cdu-label-text">Add to cart</span></button>' +
              '</div>' +
              '<a class="cdu-qv__more" href="/products/' + esc(d.handle || c.offer) + '">See full details</a>' +
            '</div>' +
          '</div>';
        document.body.appendChild(dlg);
        state.qv = dlg;

        // Photos: swipe (native scroll-snap), arrows, dots and left/right keys.
        var strip = dlg.querySelector('.cdu-qv__track');
        var cur = 0, scrollTimer = null, animTimer = null, animating = false;
        function setNav(i) {
          cur = i;
          var prev = dlg.querySelector('.cdu-qv__nav--prev'), next = dlg.querySelector('.cdu-qv__nav--next');
          if (prev) prev.disabled = cur <= 0;
          if (next) next.disabled = cur >= nImg - 1;
          dlg.querySelectorAll('[data-cdu-qv-go]').forEach(function (b, j) { b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
        }
        // Arrows/dots move the index right away, so two quick taps move two photos.
        // Snapping is off while the arrow animation runs: otherwise a photo that
        // finishes loading mid-animation makes the browser re-snap back to photo 1.
        function settle() {
          clearTimeout(animTimer);
          strip.style.scrollSnapType = '';
          animating = false;
        }
        function goTo(i) {
          i = Math.max(0, Math.min(nImg - 1, i));
          setNav(i);
          animating = true;
          strip.style.scrollSnapType = 'none';
          strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' });
          clearTimeout(animTimer);
          animTimer = setTimeout(settle, 700);
        }
        if (nImg > 1) {
          // A swipe settles the index once scrolling stops.
          strip.addEventListener('scroll', function () {
            if (animating) return;
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () { setNav(Math.round(strip.scrollLeft / Math.max(strip.clientWidth, 1))); }, 80);
          }, { passive: true });
          strip.addEventListener('scrollend', function () { if (animating) settle(); });
          // A finger on the strip takes over from any arrow animation.
          strip.addEventListener('touchstart', function () { if (animating) settle(); }, { passive: true });
          dlg.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
            if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
          });
        }

        dlg.addEventListener('click', function (e) {
          var t = e.target;
          if (t === dlg || t.closest('.cdu-qv__close')) { dlg.close(); return; }
          if (t.closest('.cdu-qv__nav--prev')) { goTo(cur - 1); return; }
          if (t.closest('.cdu-qv__nav--next')) { goTo(cur + 1); return; }
          var dot = t.closest('[data-cdu-qv-go]');
          if (dot) { goTo(Number(dot.getAttribute('data-cdu-qv-go'))); return; }
          var step = t.closest('[data-cdu-qv-step]');
          if (step) { setQty(c, c.qty + Number(step.getAttribute('data-cdu-qv-step'))); return; }
          var btn = t.closest('button.cdu-qv__add');
          if (btn) add(c, c.qty, btn, surface, 'popup');
        });
        dlg.addEventListener('close', function () {
          dlg.remove();
          document.documentElement.style.overflow = prevOverflow;
          if (state.qv === dlg) state.qv = null;
        });
        var prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dlg.showModal();
        dl('cdu_quickview_open', c, { cdu_surface: surface });
        log('quick view', c.offer);
      }

      function setQty(c, n) {
        var max = c.mode === 's' ? 6 : 8;
        c.qty = Math.min(max, Math.max(1, n));
        state.qty[c.qk] = c.qty;
        // Keep every copy (drawer, page, popup) in sync without a full re-render.
        document.querySelectorAll('tr[data-key="' + c.key.replace(/"/g, '') + '"] > .cdu-cell').forEach(function (cell) {
          cell.setAttribute('data-cdu-state', 'offer:' + c.offer + ':' + c.qty);
          var q = cell.querySelector('[data-cdu-qty]');
          if (q) q.textContent = c.qty;
        });
        var qq = state.qv && state.qv.querySelector('[data-cdu-qv-qty]');
        if (qq) qq.textContent = c.qty;
      }

      function offerFor(el) {
        var row = el.closest('tr[data-key]');
        return row && state.alloc.filter(function (x) { return x.key === row.getAttribute('data-key'); })[0];
      }

      // Only clicks inside our own row are handled; everything else (the theme's
      // quantity buttons included) is left alone. No stopPropagation: Intelligems'
      // click tracking on .cdu-add listens on document.
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        var box = t.closest('.cdu-offer');
        if (!box) return;
        e.preventDefault();
        var c = offerFor(box);
        if (!c) return;
        var surface = box.classList.contains('cdu-offer--page') ? 'page' : 'drawer';
        var step = t.closest('[data-cdu-step]');
        if (step) { setQty(c, c.qty + Number(step.getAttribute('data-cdu-step'))); return; }
        var btn = t.closest('button.cdu-add');
        if (btn) { add(c, c.qty, btn, surface, 'row'); return; }
        if (t.closest('[data-cdu-open]')) openQuickView(c, surface);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var t = e.target;
        if (!(t instanceof Element) || !t.matches('.cdu-offer [data-cdu-open]')) return;
        e.preventDefault();
        var c = offerFor(t);
        if (c) openQuickView(c, t.closest('.cdu-offer--page') ? 'page' : 'drawer');
      });

      /* ---------- lifecycle ---------- */

      function prefetch() {
        lines().forEach(function (l) { if (l.offer) product(l.offer); });
      }

      function init() {
        css();
        prefetch();
        render();
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var t = muts[i].target;
            if (t instanceof Element && t.closest('.cdu-cell')) continue;
            // Same microtask as the theme's morph: re-attach before the browser paints.
            render();
            return;
          }
        }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-key'] });
        // The quantity input's value can change without a DOM mutation (typing, morph setting .value).
        document.addEventListener('change', function (e) { if (e.target && e.target.name === 'updates[]') render(); }, true);
      }

      window.__cartDiningUpsellInfo = function () {
        var info = {
          version: VERSION,
          rowsWithOffer: lines().filter(function (l) { return l.offer; }).length,
          lines: lines().map(function (l) { return (l.handle || l.vid) + ' x' + l.qty + (l.offer ? ' -> ' + l.offer : ''); }),
          offers: state.alloc.map(function (c) { return { line: c.trigger, offer: c.offer, qty: c.qty, price: igPrice(c.data).price }; }),
          rowsInDom: rows().length,
          rendered: document.querySelectorAll('.cdu-offer').length,
          igLoaded: !!(window.igData && window.igData.price),
          errors: state.errors.slice(-5)
        };
        try { console.table(info.offers); } catch (e) {}
        return info;
      };

      try { console.log('[cart-dining-upsell] loaded v' + VERSION); } catch (e) {}

      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
    })();

  }

  if (enabled()) run();
})();
